import * as types from '../actions/types';

const initialState = {
  lessonPlanList: [],
  isLoading: false,
  isError: false,
  pagesCount:0,
  lessonPlanListCur: [],
  termLessonPlan: []
};

export default function lessonPlan(state = initialState, action) {
  switch (action.type) {
    case types.GET_LESSON_PLAN_REQUEST_STARTED:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case types.GET_LESSON_PLAN_REQUEST_COMPLETED:
    return {
        ...state,
        lessonPlanList: action.data,
        isLoading: false,
        isError: false,
      };
    case types.GET_LESSON_PLAN_CURRICULM:
    return {
        ...state,
        lessonPlanListCur: action.data,
      };
    case types.GET_LESSON_PLAN_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case types.SET_LESSON_PLAN_COUNT:
      return {
        ...state,
        pagesCount: action.data,
      };
    case types.GET_LESSON_PLAN_TERM_REQUEST_COMPLETED:
      return {
        ...state,
        termLessonPlan: action.data,
        };

    default:
      return state;
  }
}
